import "typeface-overpass";  // custom typefaces
import "typeface-open-sans";

// GatsbyJs's wrapPageElement
import PageWrapper from "./gatsby-wrapPageElement";
export const wrapPageElement = PageWrapper;
